import React from 'react';
import { datadogLogs } from '@datadog/browser-logs';
import { datadogRum } from '@datadog/browser-rum-slim';
import { useBalance } from 'wagmi';
import { useConnectedAuth } from '@context/auth/connected';
import { formatWeiToEthForDisplay } from '@utils/helpers';
import { useAuth } from '../context/auth/base';

export function DatadogGlobalScope() {
  const { authUser } = useAuth();
  const { dynamicUser, walletAddress, activeChainIdWithFallback } = useConnectedAuth();
  const { data: balanceData } = useBalance({
    address: walletAddress || '0x000',
    enabled: !!walletAddress,
    formatUnits: 'gwei',
    chainId: activeChainIdWithFallback.current,
  });

  React.useEffect(() => {
    if (!authUser) {
      datadogRum.removeUser();
      datadogLogs.clearUser();
      return;
    }

    datadogRum.setGlobalContextProperty('walletInfo', {
      dynamicUser,
      balance: balanceData
        ? `${formatWeiToEthForDisplay({
            weiValue: balanceData.value.toString(),
            maxDecimals: 4,
          })} ETH`
        : undefined,
    });

    const user = {
      id: authUser.id,
      email: authUser.email ?? undefined,
      publicAddress: authUser.publicAddress,
      artistId: authUser.artist?.id,
    };

    datadogRum.setUser(user);
    datadogLogs.setUser(user);
  }, [authUser, balanceData, dynamicUser]);

  return null;
}
